import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-activity',
  templateUrl: './activity.component.html',
  styleUrls: ['./activity.component.scss']
})
export class ActivityComponent {
  colors: string[] = [];
  @Input() data;
  public show: boolean = false
  constructor() {}

  toggle() {
    this.show = !this.show
  }

  public activity;

  ngOnInit(): void {
    this.activity = this.data.events;

    this.activity.forEach(() => {
      this.colors.push(this.color);
    });
  }

  get color(): string {

    const colors = ['primary', 'secondary', 'success', 'danger', 'warning', 'info'];
    const randomIndex = Math.floor(Math.random() * colors.length);
    return colors[randomIndex];
  }
}
